const SIGN_OUT_PATHS = new Set(['/sign/out', '/logout']);

export function isSignOutPath(pathname) {
    if (typeof pathname !== 'string') return false;

    const withoutTrailingSlashes = pathname.replace(/\/+$/, '');
    const normalizedPathname = (withoutTrailingSlashes || '/').toLowerCase();

    return SIGN_OUT_PATHS.has(normalizedPathname);
}

export function shouldLoadBootstrapData(pathname) {
    return !isSignOutPath(pathname);
}

export function performSignOut({currentIdentity, setCurrentIdentity, navigate}) {
    if (currentIdentity) {
        setCurrentIdentity(null);
    }
    navigate('/', {replace: true});
}
